import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import './App.css';
import './styles/central.css';
import Layout from './components/Layout';
import Home from './pages/Home';
import Contratos from './pages/Contratos';
import Cadastro from './pages/Cadastro';
// import CadastroFinal from './pages/CadastroFinal';
import Sucesso from './pages/Sucesso';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Planos from './pages/Planos';
import Faturas from './pages/Faturas';
import Suporte from './pages/Suporte';
import SuporteCentral from './pages/SuporteCentral';
import Perfil from './pages/Perfil';
import AlterarSenha from './pages/AlterarSenha';
import Notificacoes from './pages/Notificacoes';
import TicketsAtendido from './pages/TicketsAtendido';

/** NGINX serve a mesma SPA em / e em /centraldoassinante/; o Router precisa de basename no subpath. */
const CENTRAL_BASENAME = '/centraldoassinante';

function getRouterBasename() {
  if (typeof window === 'undefined') return undefined;
  const p = window.location.pathname;
  if (p === CENTRAL_BASENAME || p.startsWith(`${CENTRAL_BASENAME}/`)) {
    return CENTRAL_BASENAME;
  }
  return undefined;
}

// Redireciona /tecnicos para a página estática de login (evita que o React capture a rota em dev)
function RedirectTecnicos() {
  const { pathname } = useLocation();
  if (pathname === '/tecnicos' || pathname === '/tecnicos/') {
    window.location.href = '/tecnicos/login.html';
    return null;
  }
  return null;
}

function App() {
  const basename = getRouterBasename();
  const isCentralSpaMount = basename === CENTRAL_BASENAME;

  return (
    <Router basename={basename}>
      <RedirectTecnicos />
      <Routes>
        {/* Site Institucional — na raiz do domínio; em /centraldoassinante/ a raiz redireciona ao login */}
        <Route
          path="/"
          element={
            isCentralSpaMount ? (
              <Navigate to="/login" replace />
            ) : (
              <Layout>
                <Home />
              </Layout>
            )
          }
        />
        <Route path="/contratos" element={
          <Layout>
            <Contratos />
          </Layout>
        } />
        <Route path="/cadastro" element={
          <Layout>
            <Cadastro />
          </Layout>
        } />

        {/* <Route path="/cadastro-final" element={
          <Layout>
            <CadastroFinal />
          </Layout>
        } /> */}
        <Route path="/sucesso" element={
          <Layout>
            <Sucesso />
          </Layout>
        } />
        <Route path="/suporte" element={
          <Layout>
            <Suporte />
          </Layout>
        } />

        {/* Central do Assinante */}
        <Route path="/login" element={
          <Layout>
            <Login />
          </Layout>
        } />
        <Route path="/central" element={
          <Layout>
            <Dashboard />
          </Layout>
        } />
        <Route path="/central/planos" element={
          <Layout>
            <Planos />
          </Layout>
        } />
        <Route path="/central/faturas" element={
          <Layout>
            <Faturas />
          </Layout>
        } />
        <Route path="/central/suporte" element={
          <Layout>
            <SuporteCentral />
          </Layout>
        } />
        <Route path="/central/perfil" element={
          <Layout>
            <Perfil />
          </Layout>
        } />
        <Route path="/central/alterar-senha" element={
          <Layout>
            <AlterarSenha />
          </Layout>
        } />
        <Route path="/central/notificacoes" element={
          <Layout>
            <Notificacoes />
          </Layout>
        } />

        <Route path="/tickets" element={
          <Layout>
            <TicketsAtendido />
          </Layout>
        } />

        {/* Redirecionamento para Central do Assinante */}
        <Route path="/assinante" element={<Login />} />
        <Route path="/cliente" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default App; 